module.exports = {
    title: "到店核销_惠合科技数字营销方案_领券、到店、扫码核销一体化",
    description: "惠合科技到店核销方案打通了“在线领券-导航到店-扫码核销”营销闭环，提供“三码合一”落地方案，支持折扣券、满减券、提货券、代金券多种奖励形式。",
    keywords: "电子卡券,微信卡券,到店核销,扫码核销,门店核销,一物一码"
}